import { useEffect, useState } from "react";
import { Carousel, Col, Row } from "react-bootstrap";
import { fetchHomePhotos } from "../contexts/fetchGalleryData";




const CarouselHome = () => {

    const [data, setData] = useState([]);

    useEffect(() => {
        fetchHomePhotos(setData);
        return () => {
            setData([]);
        };
    }, []);



    return (
        <Row>
            <Col xs='12' 
                xl={{offset: 2, span: 8}}
                lg={{offset: 1, span: 10}}
                md={{offset: 0, span: 12}}
            >
                <Carousel fade interval={5000} style={{maxHeight: '200px'}}>
                {data.map((src, i) => (
                    <Carousel.Item key={i}>
                        <div /*className="carousel-img-wrapper"*/ style={{alignContent: 'center', justifyContent: 'center', display: 'flex', backgroundColor: '#f0f0f0'}}>
                            <img src={src.url} alt={`Slide ${i + 1}`} style={{maxHeight: "200px", width: '100%', objectFit: 'cover', objectPosition: 'center'}} />
                        </div>
                    </Carousel.Item>
                ))}
                </Carousel>

            </Col>
        </Row>
    )
}

export default CarouselHome;